import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';

const UsersPage: React.FC = () => {
    return (
        <Box sx={{ p: 3 }}>
            <Typography variant="h4" sx={{ mb: 3 }}>
                Users
            </Typography>
            <Button variant="contained" color="primary" component={Link} to="/users/invite">
                Invite User
            </Button>
        </Box>
    );
};

export default UsersPage;
